<script lang="ts" setup>
import PlugIcon from '~/assets/icons/plugs/category.svg'

const props = withDefaults(defineProps<{
  categoryName: string
  categorySlug: string | undefined
  categoryImage: string | null | undefined
  linkFromCatalog?: boolean
  categoryUrl?: string
}>(),{
  linkFromCatalog: true
})

const router = useRoute()


const linkTo:ComputedRef<string | undefined> = computed(()=>{
  if(props.linkFromCatalog){
    return `${router.path}/${props.categorySlug}`
  }else if(!props.categoryUrl){
    return '/catalog'
  }else{
    return `/catalog/${props.categoryUrl}`
  }
})

</script>

<template>
  <NuxtLink
    :to="linkTo"
    class="category"
  >
    <div class="category-name">{{ categoryName }}</div>
    <div class="category-img__wrapper">
      <nuxt-img
        v-if="categoryImage"
        class="category-img"
        loading="lazy"
        :src="categoryImage"
        alt=""
        width="160"
        height="120"
      />
      <PlugIcon v-else/>
    </div>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.category {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 196px;
  border-radius: 16px;
  background-color: $control-bg_neutral;
  transition: 0.2s background-color;
  padding: 16px 16px 0;
  @include md-breakpoint{
    position: relative;
    padding: 0;
  }
  &-name {
    hyphens: auto;
    color: $content_primary;
    @include font(16px, 20px, 500);
    @include md-breakpoint{
      padding: 8px 10px 0 10px;
      position: absolute;
      top: 0;
      @include font(14px, 20px, 500);
    }
  }
  &-img {
    width: 100%;
    height: 100%;
    mix-blend-mode: multiply;
    object-fit: contain;

    &__wrapper {
      height: 120px;
      max-width: 160px;
      width: 100%;
      margin: 0 auto;
      min-height: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      @include md-breakpoint{
        margin-top: auto;
        height: 100px;
        width: 134px;
      }
    }
  }

  @include lg-breakpoint {
    height: 152px;
  }

  @include mf-breakpoint {
    &:hover {
      background-color: $control-bg_neutral-hover;
    }
  }
}
</style>
